import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { VendorBanksModelDto } from './vendor-banks-model';
export class VendorBanksResponseModel extends GlobalResponseObject{
    data?: VendorBanksModelDto[];

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: VendorBanksModelDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}
